import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text } from "react-native";

import { Loader } from "components";
import { UpdateModal, TokenCheck } from "utils";

import { isLoading } from "state/modules/loading";
import { discardSurvey } from "state/modules/survey";
import { getFeedbackCollectedCount } from "state/modules/taker";
import { GET_DIVISION } from "state/modules/division/types";
import { getDivision, getBenchmarkAchieved } from "state/modules/division";
import { POST_LOGIN_IMAGE } from "state/modules/taker/types";
import {
  GET_QUESTIONNAIRES,
  GET_OPTION_IMAGE,
  GET_QUESTION_IMAGE,
} from "state/modules/questionnaires/types";

import Layout from "screens/common";

import { styles } from "./styles";

class Stats extends Component {
  componentDidMount = () => {
    this.props.getDivision();
    this.props.discardSurvey();
  };

  getLoadingMessage = () => {
    const {
      isDivisionLoading,
      isQuestionnaireLoading,
      isPictureLoading,
    } = this.props;
    const {
      completedCount: oCompletedCount = 0,
      pendingCount: oPendingCount = 0,
    } = this.props.optionImagesLoadingStatus;
    const {
      completedCount: qCompletedCount = 0,
      pendingCount: qPendingCount = 0,
    } = this.props.questionImagesLoadingStatus;

    const completedCount = oCompletedCount + qCompletedCount;
    const pendingCount = oPendingCount + qPendingCount;

    if (isDivisionLoading) {
      return "Loading Division Stats";
    }
    if (isQuestionnaireLoading && pendingCount === 0) {
      return "Loading Questionnaires";
    }
    if (isPictureLoading) {
      return "Uploading Picture";
    }
    return `Loading Images: ${completedCount}/${pendingCount}`;
  };

  next = () => this.props.navigation.navigate("start");
  prev = () => this.props.navigation.navigate("group");

  render = () => {
    const { division, taker } = this.props;
    const { achieved, submitted, stored, collected } = this.props;
    const { isPictureLoading, isDivisionLoading } = this.props;
    const { isQuestionnaireLoading } = this.props;

    if (isDivisionLoading || isQuestionnaireLoading || isPictureLoading)
      return <Loader message={this.getLoadingMessage()} />;

    return (
      <Layout next={this.next} prev={this.prev}>
        <View style={styles.container}>
          <StatBox heading={division.level.name} content={division.title} />
          <StatBox
            heading="Name"
            content={taker.first_name + " " + taker.last_name}
          />
          <StatBox heading="Phone Number" content={taker.cell_phone || "--"} />
          <StatBox heading="Email" content={taker.email || "--"} />
          <StatBox
            heading="Division Benchmark"
            content={`${achieved}/${division.benchmark.target}`}
          />
          <StatBox heading="Feedback Collected" content={collected} />
          <StatBox heading="Feedback Submitted" content={submitted} />
          <StatBox heading="Offline Feedbacks" content={stored} />
        </View>
        <UpdateModal />
        <TokenCheck />
      </Layout>
    );
  };
}

const StatBox = ({ heading, content }) => {
  return (
    <View style={[styles.statBox]}>
      <Text style={[styles.text, styles.heading]}>{heading}</Text>
      <Text style={[styles.text, styles.content]}>{content}</Text>
    </View>
  );
};

const mapDispatchToProps = {
  getDivision,
  discardSurvey,
};

const mapStateToProps = state => {
  return {
    division: state.division,
    taker: state.taker,
    submitted: state.taker.submitted,
    stored: state.feedback.cached.length,
    collected: getFeedbackCollectedCount(state),
    achieved: getBenchmarkAchieved(state),
    isDivisionLoading: isLoading(state, [GET_DIVISION]),
    isPictureLoading: isLoading(state, [POST_LOGIN_IMAGE]),
    isQuestionnaireLoading: isLoading(state, [GET_QUESTIONNAIRES]),
    optionImagesLoadingStatus: state.loading[GET_OPTION_IMAGE] || {},
    questionImagesLoadingStatus: state.loading[GET_QUESTION_IMAGE] || {},
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Stats);
